/**
 * Form Validation Functions
 * ES5-compatible validation utilities for profile forms
 */

(function(window) {
    'use strict';

    var validators = {
        /**
         * Validate email format
         * @param {string} value - Email address to validate
         * @returns {object} {valid: boolean, message: string}
         */
        email: function(value) {
            var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            var msg = (window.Validators_I18N && window.Validators_I18N.emailInvalid) || 'Please enter a valid email address';
            return {
                valid: regex.test(value),
                message: msg
            };
        },

        /**
         * Validate bio length
         * @param {string} value - Bio text
         * @returns {object} {valid: boolean, message: string}
         */
        bio: function(value) {
            var msg = (window.Validators_I18N && window.Validators_I18N.bioInvalid) || 'Bio must be 240 characters or less';
            return {
                valid: value.length <= 240,
                message: msg
            };
        },

        /**
         * Validate name (first or last)
         * @param {string} value - Name
         * @returns {object} {valid: boolean, message: string}
         */
        name: function(value) {
            if (!value || value.trim() === '') {
                return {
                    valid: true, // Allow empty names
                    message: ''
                };
            }
            var regex = /^[\p{L}\s'-]{1,50}$/u;
            var msg = (window.Validators_I18N && window.Validators_I18N.nameInvalid) || 'Names can only contain letters, spaces, hyphens, and apostrophes';
            return {
                valid: regex.test(value),
                message: msg
            };
        },

        /**
         * Validate password strength
         * @param {string} value - Password
         * @returns {object} {valid: boolean, message: string, strength: object}
         */
        password: function(value) {
            var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
            var strength = this.calculatePasswordStrength(value);
            var msg = (window.Validators_I18N && window.Validators_I18N.passwordStrength) || 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character';
            return {
                valid: regex.test(value),
                message: msg,
                strength: strength
            };
        },

        /**
         * Validate confirm password matches
         * @param {string} value - Confirm password
         * @param {string} passwordValue - Original password
         * @returns {object} {valid: boolean, message: string}
         */
        confirmPassword: function(value, passwordValue) {
            var msg = (window.Validators_I18N && window.Validators_I18N.passwordsMismatch) || 'Passwords do not match';
            return {
                valid: value === passwordValue,
                message: msg
            };
        },

        /**
         * Calculate password strength
         * @param {string} password - Password to evaluate
         * @returns {object} {score: number, level: string, requirements: object}
         */
        calculatePasswordStrength: function(password) {
            var score = 0;
            var requirements = {
                length: password.length >= 8,
                uppercase: /[A-Z]/.test(password),
                lowercase: /[a-z]/.test(password),
                number: /\d/.test(password),
                special: /[@$!%*?&]/.test(password)
            };

            for (var key in requirements) {
                if (requirements[key]) score++;
            }

            return {
                score: score,
                level: score <= 2 ? 'weak' : score <= 4 ? 'medium' : 'strong',
                requirements: requirements
            };
        },

        /**
         * Update bio character counter
         * @param {HTMLTextAreaElement} bioField - Bio textarea element
         * @param {HTMLElement} counter - Counter display element
         */
        updateBioCounter: function(bioField, counter) {
            if (!bioField || !counter) return;

            var remaining = 240 - bioField.value.length;
            counter.textContent = remaining + ' characters left';

            // Color coding
            counter.classList.remove('text-green-600', 'text-yellow-600', 'text-red-600');
            if (remaining > 50) {
                counter.classList.add('text-green-600');
            } else if (remaining > 20) {
                counter.classList.add('text-yellow-600');
            } else {
                counter.classList.add('text-red-600');
            }
        },

        /**
         * Show error message for a field
         * @param {HTMLElement} field - Input field
         * @param {string} message - Error message
         */
        showError: function(field, message) {
            if (!field) return;

            var errorSpan = field.parentElement.querySelector('.error-message');
            if (errorSpan) {
                errorSpan.textContent = message;
                errorSpan.classList.remove('hidden');
            }

            // Add error styling
            field.classList.add('border-red-500');
            field.classList.remove('border-gray-200');
        },

        /**
         * Clear error message for a field
         * @param {HTMLElement} field - Input field
         */
        clearError: function(field) {
            if (!field) return;

            var errorSpan = field.parentElement.querySelector('.error-message');
            if (errorSpan) {
                errorSpan.textContent = '';
                errorSpan.classList.add('hidden');
            }

            // Remove error styling
            field.classList.remove('border-red-500');
            field.classList.add('border-gray-200');
        },

        /**
         * Show success indicator for a field
         * @param {HTMLElement} field - Input field
         */
        showSuccess: function(field) {
            if (!field) return;

            field.classList.add('border-green-500');
            field.classList.remove('border-gray-200', 'border-red-500');
        }
    };

    // Expose validators globally
    window.Validators = validators;

})(window);
